export const ja = {
  returnRequestDate: {
    label: "返品リクエストは{{date}} {{time}}に送信されました",
  },
  actions: {
    continue: "続ける",
  },
  "order-identification": {
    title: "注文を追跡する",
    description: "注文の詳細を入力して荷物を追跡してください",
    fields: {
      "zip-code": {
        title: "郵便番号",
        description: "配達先の郵便番号を入力してください",
        required: "郵便番号は必須です",
      },
      "tracking-number": {
        title: "注文番号",
        description: "注文番号を入力してください",
        required: "注文番号は必須です",
      },
    },
    errors: {
      "unknown-order": {
        title: "注文番号が不明です",
        description: "注文番号が見つかりませんでした。ご確認ください",
      },
      "order-not-shipped": {
        title: "注文準備中",
        description: "ご注文はまだ発送されていません",
      },
      "search-error": {
        title: "検索エラー",
        description: "注文を検索できませんでした。後ほど再度お試しください。",
      },
    },
  },
  delivery: "配送",
  "parcel-history": "荷物の履歴",
  "order-details": {
    title: "注文の詳細",
    "tracking-number": "追跡番号",
    "order-number": "注文番号",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "配達予定日",
      deliveredOn: "配達日",
      from: "から",
      to: "まで",
    },
  },
  deliveryAddress: {
    title: "配送先住所：",
    titlePickup: "受取ポイントの住所：",
    orderDetails: {
      title: "注文の詳細：",
      trackingNumber: "追跡番号：",
      orderNumber: "注文番号：",
      orderDate: "注文日：",
    },
  },
  pickupPoint: {
    title: "受取ポイント",
    openingHours: "営業時間：",
    closed: "閉店",
    directions: "道順",
    days: {
      monday: "月曜日：",
      tuesday: "火曜日：",
      wednesday: "水曜日：",
      thursday: "木曜日：",
      friday: "金曜日：",
      saturday: "土曜日：",
      sunday: "日曜日：",
    },
  },
  wallet: {
    warningNotEnabled: "店舗設定でウォレットを有効にする必要があります",
  },
  crossSell: {
    youMightAlsoLike: "こちらもおすすめ",
  },
  "rate-order": {
    "order-recap": {
      title: "ご注文",
      "tracking-label": "追跡番号：",
      "order-label": "注文番号：",
    },
    form: {
      title: "配送を評価する",
      "rating-label": "配送体験を評価してください",
      "comment-label": "コメント（任意）",
      "comment-placeholder": "ご体験を共有してください…",
      "submit-cta": "レビューを送信",
      "update-cta": "レビューを更新",
      "rating-required": "評価を選択してください。",
    },
    "thank-you": {
      title: "フィードバックありがとうございます！",
      description:
        "レビューが保存されました。配送体験の改善に役立ちます。",
    },
    errors: {
      "invalid-token": {
        title: "リンクが無効または期限切れです",
        description:
          "このリンクはもう有効ではありません。最新の追跡メールから再度開いてください。",
      },
      submit: {
        title: "エラーが発生しました",
        description:
          "レビューを保存できませんでした。後ほど再度お試しください。",
      },
    },
  },
  shippingInstructions: {
    colissimo: "返品ラベルを印刷し、最寄りのColissimo中継ポイントに商品をお持ちください。",
    chronoShop2Shop: "返品ラベルを印刷し、最寄りのChronopost中継ポイントに商品をお持ちください。",
    ups: "返品ラベルを印刷し、最寄りのUPS中継ポイントに商品をお持ちください。",
    customerCarrier: "お好みの配送業者に返品商品をお渡しください。",
    merchantCarrier: "1〜3営業日以内に返品ラベルをメールでお送りいたします。",
    returnToStore: "返品ラベルを印刷し、最寄りの店舗に商品をお持ちください。",
    malca: "返品ラベルを印刷し、最寄りのMalca中継ポイントに商品をお持ちください。",
    tnt: "返品ラベルを印刷し、最寄りのTNT中継ポイントに商品をお持ちください。",
    bonDeRetour: "返品伝票の準備ができました。印刷して返品にご利用ください。",
  },
  downloadLabel: {
    label: "ラベルをダウンロード",
    bonDeRetour: "返品伝票をダウンロード",
  },
} as const;
